import React , {useState , useEffect } from 'react'
import { Table} from 'antd';
import api from "utils/api";
import {message} from "antd";
import { Button,Pagination } from 'antd';
import utils from "utils";
import FormAddMedicine from "Components/FormAddMedicine";
import "../CareAdmin/CareAdmin.scss";
const DataDisplay = (data)=>{
    if(data?.frequency) return <span>{data?.frequency?.morning || 0}{(data?.frequency?.frequency_measurement && data?.frequency?.morning) ? data?.frequency?.frequency_measurement : ""} - {data?.frequency?.noon || 0} {(data?.frequency?.frequency_measurement && data?.frequency?.noon) ? data?.frequency?.frequency_measurement : ""} - {data?.frequency?.evening || 0}{(data?.frequency?.frequency_measurement && data?.frequency?.evening) ? data?.frequency?.frequency_measurement : ""} - {data?.frequency?.night || 0}{(data?.frequency?.frequency_measurement && data?.frequency?.night) ? data?.frequency?.frequency_measurement : ""} </span>
    if(data?.dosage?.dosage) return <span>{data.dosage.dosage}</span>
    if(data?.duration?.duration) return <span>{data.duration.duration}</span>
    return data?.val ? <span>{data.val}</span> : <></>;
}
const MedicineList = () =>{
  const [data, setdata] = useState([]);
  const [count,setCount] = useState(0);
  const [pageNo,setPageNo] = useState(1);
  const [pageSize,setPageSize] = useState(20);
  const [isinnerLoading,setisinnerLoading] = useState(false);
  const [openDrawer,setOpenDrawer] = useState(false);
  const columns = [
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'utype',
        render: (data) =>{
            let result= [];
            for (let [k, value] of Object.entries(data)) {
                if(value) result.push(utils.ConvertToPascalCase((k.substring(3, k.length))))
            }        
        return (<span>{result.join()}</span>)
        }
    },
    {
        title: 'Drug',
        dataIndex: 'medicine',
        key: 'umedicine',
        render: (data) => (<DataDisplay val={data.medicine} />)
    },
    {
        title: 'Brand',
        dataIndex: 'brand',
        key: 'ubrand',
        render: (data) => (<DataDisplay val={data.brand} />)
    },
    {
        title: 'Form',
        dataIndex: 'form',
        key: 'uform',
        render: (data) => (<DataDisplay val={data.form} />)
    },
    {
        title: 'Route',
        dataIndex: 'route',
        key: 'uroute',
        render: (data) => (<DataDisplay val={data.route} />)
    },
    {
        title: 'Adjuvant',
        dataIndex: 'adjuvant',
        key: 'uadjuvant',
        render: (data) => (<DataDisplay val={data.adjuvant} />)
    },
    {
        title: 'Frequency',
        dataIndex: 'frequency',
        key: 'ufrequency',
        render: (data) => (<DataDisplay frequency={data}/>
        )
    },
    {
        title: 'Dosage',
        dataIndex: 'dosage',
        key: 'udosage',
        render: (data) => (<DataDisplay dosage={data}/>)
    },
    {
        title: 'Duration',
        dataIndex: 'duration',
        key: 'uduration',
        render: (data) => (<DataDisplay duration={data}/>)
    },
    // {
    //     title: '',
    //     dataIndex: 'id',
    //     key: 'id',
    //     render: (index, record) => (
    //       <Button  onClick={() => console.log(record)} icon={<img src={icons.edit_icon}/>} />
    //     ),
    // },
  ];

  useEffect(() => {
    getData(pageNo,pageSize);
  }, []);

  const getData = async (pageNo,pageSize) => {
    setisinnerLoading(true)
    const res = await api.medicine_list(pageNo,pageSize);
    if(res.data.status ==200){
        let {data} = res.data ;
        setCount(data.count) 
        setPageNo(pageNo) 
        setPageSize(pageSize) 
        setdata(
            data.results.map((row,i) => ({
            id: i,
            type:row.type,
            medicine: row.medicine,            
            brand:row.brand,
            form:row.form,
            route:row.route,
            adjuvant:row.adjuvant,
            frequency:row.dosage_frequency_duration,
            dosage:row.dosage_frequency_duration,
            duration:row.dosage_frequency_duration,
          }))
        );
    }else{
        message.error(res.data?.message, ErrorDuration);
    }
    setisinnerLoading(false)
  };

  const handlePagination = (pageNo,pageSize)=> {
    pageNo= pageNo||1
    getData(pageNo,pageSize)
  }
  return (
      <>
      <div style={{ display: "flex", flexDirection:"row-reverse" }}>
        <Button
          className="confirm-btn add-drug-btn"
          onClick={() => {setOpenDrawer(true);}}
        >
          +Add Medicine
        </Button>
      </div>
      <Table className='medicine-list-tabel' size="small" loading={isinnerLoading} pagination={false} dataSource={data} columns={columns}
        scroll={{
          // x: 2400,
          y: "50vh",
        }} />
      <Pagination  hideOnSinglePage={count<=0?true:false} defaultPageSize={20} current={pageNo||1} defaultCurrent={pageNo||1} total={count} onChange={handlePagination.bind(this)}  pageSizeOptions={[20,50,100]} showSizeChanger={true} />
      <FormAddMedicine
          openDrawer={(value) => setOpenDrawer(value)}
          open_drawer={openDrawer}
          getContainer={"body"}
        />
      </>
  );
};

export default MedicineList;